import { render, staticRenderFns } from "./InsertVideoModal.vue?vue&type=template&id=6e526a56"
import script from "./InsertVideoModal.vue?vue&type=script&lang=js"
export * from "./InsertVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports